import { combineEpics, Epic, ofType } from 'redux-observable';
import { EMPTY, Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { Action } from '../../actions';
import { changeLocation } from '../../actions/common';
import {
    DEALS_NAVIGATION_GO_TO_FILTER,
    DealsNavigationGoToFilterAction
} from '../../actions/deals-navigation';
import { serializeFilterToString } from '../../service/FilterHelpers/FilterHelpers';
import { EpicDeps } from '../../service/StoreFactory';
import { UrlHelpers } from '../../service/UrlHelpers';
import { DealsScreenUrlSearchParam } from '../../typings/deals';
import { State } from '../../typings/state';

export const dealsNavigationGoToFilterEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$) => {
    return action$.pipe(
        ofType(DEALS_NAVIGATION_GO_TO_FILTER),
        mergeMap(
            (action: DealsNavigationGoToFilterAction): Observable<Action> => {
                const { pathname, query = {} } = store$.value.router;

                const newFilter = serializeFilterToString(action.expressions);

                if (newFilter !== query.filter) {
                    return of(
                        changeLocation(
                            pathname,
                            UrlHelpers.normalizeQuery({
                                [DealsScreenUrlSearchParam.filter]: newFilter
                            })
                        )
                    );
                }
                return EMPTY;
            }
        )
    );
};

export const dealsNavigationEpic = combineEpics(dealsNavigationGoToFilterEpic);
